import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { HOURS_EXCEPTION_BASE_PATH } from '../../../../../../features/hours/exception/hours-exception-routing';

export const Route = createFileRoute('/_app/_clearing-core/hours/_hours/exception/_exception')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'hours-exception-list',
        label: 'Hours',
        to: HOURS_EXCEPTION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
